/**
 * Cliente HTTP compartido (Axios con baseURL, token, interceptors).
 * Usar desde los *.service.js; no instanciar Axios en otro sitio.
 */
import http from '@/plugins/axios';

export default http;
